
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import { Button, Dialog } from 'vant'
import InfiniteLoading from 'vue-infinite-loading'
import {
    Header,
    Banner,
    Map,
    Title,
    GoodsList,
    StoreInfo
} from '@/components/customPromotion'
import {
    getPromotionGoodsInfo
} from '@/models/custom'
import {
    getRegularInfo
} from '@/models/regularPromotionDetail'
import {
    setLocalConfig,
    getLocalConfig
} from '@/utils/storage.js'
import _ from 'lodash'
import { queryKey } from '@/utils/util'
import { isIOS, isAndroid } from '@/utils/ua'
import { wxShare } from '@/utils/wxsdk'

export default {
    name: viewName.regularCustomDetail,
    inject: ['showLoading', 'hideLoading'],
    components: {
        [Button.name]: Button,
        InfiniteLoading,
        Header,
        Banner,
        Map,
        Title,
        GoodsList,
        StoreInfo,
        [Dialog.name]: Dialog
    },
    data () {
        return {
            detailParams: {
                topic_id: '', // 推广id
                store_id: '', // 商家id
            },
            page_size: 12,
            page_no: 1,
            pageStatus: true,
            page_bg_color: '', // 页面背景颜色
            banner: {
                url: '', // 头图
                title: '', // 大标名称
                title_size: '', // 大标字体大小
                title_family: '', // 大标字体
                title_color: '', // 大标字体颜色
                sub_title: '', // 小标名称
                sub_title_size: '', // 小标字体大小
                sub_title_family: '', // 小标字体
                sub_title_color: '', // 小标字体颜色
            },
            store: {
                store_name: '', // 商家名称
                store_img: '', // 商家图片
                certification: true, // 是否显示资质, true:显示， false：不显示
                // 信用
                credit: {
                    type: 0, // 0：不显示信用， 1：红心, 2: 钻石, 3: 蓝冠, 4: 黄冠
                    value: 0, // 信用图片数量, 最多5个，最小就是不显示为0
                    image: '', // 图标链接
                },
                intro: '', // 商家简介
            },
            floor_bg_img: '', // 热销名称背景图片
            goodsList: [
                // {
                //     spu_id: '', // 商品规格id
                //     goods_id: '', // 商品id
                //     goods_img: '', // 商品图片
                //     goods_name: '', // 商品名称
                //     goods_price: '', // 商品原价
                //     goods_present_price: '', // 商品现价
                //     goods_sell_out: 1 || 0, // 是否已售罄, 0: 未售罄, 1： 已售罄
                // }
            ],
            position: {
                longitude: '',
                latitude: ''
            },
            isPosition: false,
            address: '',
            share: {
                title: '', // 分享标题
                desc: '', // 分享描述
                imgUrl: '', // 分享图片
            },
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin,
            icarAppInfo: ({ appInfo }) => appInfo.icarAppInfo
        }),
        isApp () {
            return this.icarAppInfo.app_name === 'iCar_app'
        },
    },
    watch: {
        isPosition (newValue) {
            if (newValue) {
                if (!this.address) {
                    this.getAddressData()
                }
            }
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            // Object.assign(vm.detailParams, to.query)
            vm.page_bg_color && vm.doBgColor()
        })
    },
    created () {
        this.setAppClass({
            isAppend: true,
            className: 'bgGreyColor'
        })
    },
    activated () {
        Object.assign(this.detailParams, this.$route.query)
        const status = getLocalConfig('isChangePosition')
        if (status === '1' && this.pageStatus) {
            this.initLocation()
            setLocalConfig('isChangePosition', '0')
        }
    },
    deactivated () {
        this.doBgColor('del')
    },
    mounted () {
        document.body.scrollIntoView()
        Object.assign(this.detailParams, this.$route.query)
        if (queryKey(this.detailParams, ['topic_id', 'store_id'])) {
            this.initLocation()
            this.getRegularData()
        } else {
            this.pageStatus = false
            Dialog.alert({
                message: '页面缺少参数'
            })
        }
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getLocation',
            'getAddress',
            'saveAddressInfo',
        ]),
        doBgColor (type) {
            const app = document.querySelector('#app')
            const mainBox = app.querySelector('.mainBox')
            if (type === 'del') {
                app.removeAttribute('style')
                mainBox.setAttribute('style', `padding-top: ${(this.isWeixin || this.isApp) ? '0px' : '1.173333rem'}`)
            } else {
                app.setAttribute('style', `background-color: ${this.page_bg_color || '#b72021'}`)
                if ((!this.isWeixin && !this.isApp) && (isAndroid() || isIOS())) {
                    mainBox.setAttribute('style', `margin-top: 1.173333rem;padding-top:`)
                }
            }
        },
        initLocation () {
            const addressInfo = getLocalConfig('AddressInfo')
            if (addressInfo && !_.isEmpty(addressInfo)) {
                this.address = addressInfo.name
                const position = _.pick(addressInfo, ['longitude', 'latitude'])
                Object.assign(this.position, position)
                this.isPosition = true
            }
        },
        getAddressData () {
            if (!this.address) {
                this.getAddress(Object.values(this.position))
                    .then(res => {
                        const param = {
                            longitude: this.position.longitude,
                            latitude: this.position.latitude,
                            province: res.addressComponents.province,
                            city: res.addressComponents.city,
                            district: res.addressComponents.district,
                            name: res.address || '',
                            formattedAddress: res.address
                        }
                        this.address = param.name
                        this.setAddressInfo(param)
                    })
            }
        },
        setAddressInfo (params, successStatus) {
            const obj = {
                longitude: params.longitude,
                latitude: params.latitude,
                province: '广东省',
                city: '广州市',
                district: '白云区',
                name: '广州-同和地铁站',
                formattedAddress: '广州-同和地铁站'
            }
            if (!successStatus) {
                this.address = '广州-同和地铁站'
            } else {
                Object.assign(obj, params)
            }
            this.saveAddressInfo(obj)
        },
        infinite () {
            this.getRegularGoodsList()
        },
        getRegularData () {
            this.showLoading()
            getRegularInfo({
                topic_id: this.detailParams.topic_id,
                store_id: this.detailParams.store_id,
                ...this.position
            })
                .then(res => {
                    Object.assign(this, res)
                    this.$emit('setHeader', {
                        title: res.title,
                        showHeader: true,
                        showLeft: true,
                    })
                    this.isWeixin && this.wxShareConfig()
                    // 防止接口返回内容太慢，而用户点击跳转页面，导致改变了其他页面背景颜色
                    if (this.$route.path === '/regularCustomDetail') {
                        this.page_bg_color && this.doBgColor()
                    }
                    this.hideLoading()
                })
                .catch(err => {
                    if (err.errcode === 9110) {
                        this.pageStatus = false
                        this.$router.push({
                            path: '/pageNotFound',
                            query: {
                                sstore_id: this.detailParams.sstore_id || '',
                            }
                        })
                    }
                    this.hideLoading()
                })
        },
        wxShareConfig () {
            wxShare(Object.assign(this.share, { link: location.href }))
        },
        getRegularGoodsList () {
            getPromotionGoodsInfo({
                topic_type: 0, // 类型，0：常规，1：自定义
                topic_id: this.detailParams.topic_id || '',
                store_id: this.detailParams.store_id || '',
                page: this.page_no,
                pagesize: this.page_size,
                floor_type: 2, // 商品类型 1主推商品 2楼层商品
            })
                .then(data => {
                    this.goodsList.push(...data)
                    if (data.length < this.page_size) {
                        this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                    } else {
                        this.page_no += 1
                        this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        headerCallback (params) {
            const status = this.hasLocation()
            if (status) {
                const { type, cb } = params
                const query = {
                    topic_id: this.detailParams.topic_id
                }
                if (type === 'jump') {
                    Object.assign(query, {
                        title: '热销商品',
                        topic_id: this.detailParams.topic_id,
                        topic_type: 0,
                        store_id: this.detailParams.store_id,
                        page_code: 'regularCustomDetail'
                    })
                } else if (type === 'selectAddress') {
                    Object.assign(query, {city: this.address})
                    delete query.topic_id
                }
                cb(query)
            }
        },
        mapCallback (params) {
            const status = this.hasLocation()
            if (status) {
                const { type, value, cb } = params
                if (type === 'list' || type === 'map') {
                    Object.assign(value, {
                        ...this.position,
                        topic_id: this.detailParams.topic_id,
                        store_id: this.detailParams.store_id,
                        topic_type: 0,
                        isPosition: true,
                        page_code: 'regularCustomDetail'
                    })
                    cb(value)
                } else if (type === 'goodsList') {
                    // Object.assign(value, {
                    //     topic_id: this.detailParams.topic_id
                    // })
                    // cb(value)
                } else {
                    cb()
                }
            }
        },
        goodsListCallback (params) {
            const status = this.hasLocation()
            if (status) {
                const { value, cb } = params
                Object.assign(value, {
                    topic_id: this.detailParams.topic_id,
                    store_id: this.detailParams.store_id,
                    topic_type: 0,
                    page_code: 'regularCustomDetail'
                })
                cb(value)
            }
        },
        saveAddress (obj) {
            let param = {
                longitude: this.position.longitude,
                latitude: this.position.latitude,
                province: '',
                city: '',
                district: '',
                name: '广州-同和地铁站',
                formattedAddress: '广州-同和地铁站'
            }
            Object.assign(param, obj)
            this.saveAddressInfo(param)
        },
        hasLocation () {
            if (Object.values(this.position).every(item => !!item)) {
                return true
            } else {
                this.getMyLocation()
                return false
            }
        },
        getMyLocation () {
            this.showLoading()
            const options = { timeout: 3000, from: 'noTips' }
            // var geolocation = new qq.maps.Geolocation('3PDBZ-UERCW-ZBORT-OIRZ4-NKWD6-ZMBI6', 'fc')
            // geolocation.getLocation(this.showPosition, this.showErr, options)
            this.getLocation(options)
                .then(this.showPosition)
                .catch(this.showErr)
                .finally(() => {
                    this.hideLoading()
                    this.isPosition = true
                })
        },
        /* 获取位置信息成功 */
        showPosition (position) {
            this.position.longitude = position.lng
            this.position.latitude = position.lat
            // this.longitude = 113.326233
            // this.latitude = 23.197102
        },
        /* 获取位置信息失败，定位失败再请求定位，测试使用 */
        showErr () {
            // 定位同和地铁站
            this.position.longitude = 113.332926
            this.position.latitude = 23.202723
            this.setAddressInfo({
                longitude: 113.332926,
                latitude: 23.202723,
                address: '广州-同和地铁站',
                name: '广州-同和地铁站'
            }, false)
        },
    },
    destroyed () {

    },
}
